
import { supabase } from '@/integrations/supabase/client';

export interface AuthResult {
  error?: any;
  success?: boolean;
}

export const authService = {
  async signUp(email: string, password: string, firstName?: string, lastName?: string): Promise<AuthResult> {
    try {
      const { error } = await supabase.auth.signUp({
        email,
        password,
        options: {
          data: {
            first_name: firstName,
            last_name: lastName,
          }
        }
      });

      if (error) {
        return { error };
      }

      return { success: true };
    } catch (error) {
      console.error('Erreur signUp:', error);
      return { error };
    }
  },

  async signIn(email: string, password: string): Promise<AuthResult> {
    try {
      const { error } = await supabase.auth.signInWithPassword({
        email,
        password,
      });

      if (error) {
        return { error };
      }

      return { success: true };
    } catch (error) {
      console.error('Erreur signIn:', error);
      return { error };
    }
  },

  async signInWithGoogle(): Promise<AuthResult> {
    try {
      const { error } = await supabase.auth.signInWithOAuth({
        provider: 'google',
        options: {
          redirectTo: 'https://preview--feel-future-insights-compass.lovable.app/',
          queryParams: {
            access_type: 'offline',
            prompt: 'consent',
          },
        }
      });

      if (error) {
        console.error('Erreur Google OAuth:', error);
        return { error };
      }

      return { success: true };
    } catch (error) {
      console.error('Erreur Google OAuth:', error);
      return { error };
    }
  },

  async signInWithApple(): Promise<AuthResult> {
    try {
      const { error } = await supabase.auth.signInWithOAuth({
        provider: 'apple',
        options: {
          redirectTo: 'https://preview--feel-future-insights-compass.lovable.app/',
        }
      });

      if (error) {
        return { error };
      }

      return { success: true };
    } catch (error) {
      console.error('Erreur Apple OAuth:', error);
      return { error };
    }
  },

  async signOut(): Promise<void> {
    try {
      await supabase.auth.signOut();
    } catch (error) {
      console.error('Erreur signOut:', error);
    }
  }
};
